import { render, staticRenderFns } from "./CultureDesignMaterialType.vue?vue&type=template&id=b3d21f2c&scoped=true&"
import script from "./CultureDesignMaterialType.vue?vue&type=script&lang=js&"
export * from "./CultureDesignMaterialType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3d21f2c",
  null
  
)

export default component.exports